import listSaga from './listSaga'
import listByLevelSaga from './listByLevelSaga'
import listBySearchSaga from './listBySearchSaga'

const sourceCategoriesSagas = [listSaga(), listByLevelSaga(), listBySearchSaga()]

export default sourceCategoriesSagas
